// extracted by mini-css-extract-plugin
module.exports = {"item_border":"CustomHooks_item_border__2cejn","delete_not_possible":"CustomHooks_delete_not_possible__2-A3W"};